import { Plus } from "lucide-react";
import type { FaqItem as FaqData } from "@/app/marketing/constants/faq";

interface FaqItemProps {
  item: FaqData;
}

export function FaqItem({ item }: FaqItemProps) {
  return (
    <details className="group rounded-xl border border-white/10 bg-white/5 open:border-brand-violet/30 open:bg-white/[0.07]">
      <summary className="flex cursor-pointer list-none items-start justify-between gap-4 p-5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-violet rounded-xl">
        <span className="text-base font-medium text-brand-ink">{item.question}</span>
        <Plus
          className="h-5 w-5 text-brand-ink/60 shrink-0 transition-transform group-open:rotate-45"
          aria-hidden
        />
      </summary>
      <div className="px-5 pb-5 pt-1 text-sm text-brand-ink/70 leading-relaxed">
        {item.answer}
      </div>
    </details>
  );
}
